// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J7j2","inner":"styles_inner__385rj","right":"styles_right__2oJVU","close":"styles_close__1VqyT","footer":"styles_footer__2xTSH"};